import { FC } from 'react';
import { BsGeo } from 'react-icons/bs';
import { IoPricetagOutline } from 'react-icons/io5';

import { Text } from '@mantine/core';

import { CompanyPartner } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { CompanyLogo } from 'components/company-logo/CompanyLogo';
import { ProfileRow } from 'components/company-profile/components/ProfileRow';
import { VerifiedBadge } from 'components/verified-badge/VerifiedBadge';
import { useCompanyProfile } from 'hooks/use-company-profile';

const PartnerTeaser: FC<{ partner: CompanyPartner; category?: string }> = ({ partner, category }) => {
    const { company: partnerCompany } = useCompanyProfile(partner.company);

    const name = partnerCompany?.name ?? partner.name ?? '';
    const viewUrl = partnerCompany ? CompanyHelpers.urls.view(partnerCompany.slug) : partner.linkedin;
    const location = partnerCompany ? CompanyHelpers.summarizeLocations(partnerCompany.locations) : '';

    return (
        <ProfileRow
            size="lg"
            leadingShape="square"
            leading={
                <CompanyLogo
                    logos={partnerCompany?.logos ?? { small: partner.logo, large: null }}
                    width={144}
                    fallback={<Text fw={700}>{name.charAt(0)}</Text>}
                />
            }
            title={
                <>
                    {name}
                    {partnerCompany && !partnerCompany.internal && (
                        <VerifiedBadge
                            compact
                            companyName={name}
                            compactSize={14}
                            style={{ marginLeft: 6, verticalAlign: -2 }}
                        />
                    )}
                </>
            }
            meta={partner.description || category}
            metaIcon={<IoPricetagOutline />}
            details={location}
            detailsIcon={<BsGeo />}
            href={viewUrl || undefined}
            target={partnerCompany ? undefined : '_blank'}
        />
    );
};

export { PartnerTeaser };
